import { render, staticRenderFns } from "./ModalVisualizarOcorrencia.vue?vue&type=template&id=7aaa3c36&scoped=true"
import script from "./ModalVisualizarOcorrencia.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarOcorrencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaa3c36",
  null
  
)

export default component.exports